import { Component, OnInit, EventEmitter, Output, Input, } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';

@Component({
  selector: 'lib-ph-bhp-elearning',
  templateUrl: './ph-bhp-elearning.component.html',
  styleUrls: ['./ph-bhp-elearning.component.css']
})
export class PHBHPElearningComponent implements OnInit {
  @Output() childData = new EventEmitter();
  @Input() isDesktop = true;
  isSOP: boolean;
  packageSubscription: any;

  constructor(public layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    this.isSOP = this.layoutService.isMyHygieneSOPLicense(this.layoutService.packageID);
    this.packageSubscription = this.layoutService.packageIDSubject.subscribe((packageID) => {
      this.isSOP = this.layoutService.isMyHygieneSOPLicense(this.layoutService.packageID);
    });
  }

  ngOnDestroy() {
    this.packageSubscription.unsubscribe();
  }

  Managetutorials(): void {
    this.childData.emit('elearning/manage');
  }

  Managepuzzles(): void {
    this.childData.emit('elearning/puzzles');
  }


}
